"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var changes_1 = require("../changes");
var utils_1 = require("../utils");
/**
 * User pressed Delete in an editor
 */
function onBackspace(event, editor, opts, 
// tslint:disable-next-line:no-any
next) {
    var value = editor.value;
    var selection = value.selection;
    var startOffset = value.selection.start.offset;
    // Only unwrap...
    // ... with a collapsed selection
    if (selection.isExpanded) {
        return next();
    }
    // ... when at the beginning of nodes
    if (startOffset > 0) {
        return next();
    }
    // ... in a list
    var currentItem = utils_1.getCurrentItem(opts)(value);
    if (!currentItem) {
        return next();
    }
    // ... more precisely at the beginning of the current item
    if (!selection.isCollapsed && selection.anchor.isAtEndOfNode(currentItem)) {
        return next();
    }
    event.preventDefault();
    return changes_1.unwrapList(opts, editor);
}
exports.default = onBackspace;
//# sourceMappingURL=onBackspace.js.map